import { Phone } from 'lucide-react';

// Kept under the original file name to avoid churn in App.js imports.
// This now renders a "Call" floating button instead of WhatsApp.
const CallButton = () => {
  return (
    <a
      href="tel:+33983820754"
      className="call-float"
      data-testid="call-float-btn"
      aria-label="Appeler la boutique"
    >
      <Phone size={26} color="white" strokeWidth={2.2} />
    </a>
  );
};

export default CallButton;
